
import App from './app';
import * as R from 'ramda';
import * as VG from './map/vg/vg-utils';

// const App = APP(); // Just stupid

// lang :: () -> Lang
//    Lang = String
export const lang = _ => {
  const lang = getData('lang', 'all');
  return typeof lang == 'string' ? lang : defaultLang();
};

// defaultLang :: () -> Lang
//    Lang = String
export const defaultLang = _ => {
  const { defaultLanguage, languages = [] } = scimddata() || {};
  return defaultLanguage || languages[0];
};

// langs :: () -> [Lang]
export const langs = _ => {
  return scimddata().languages || [];
};


export const getData = (name, _lang = lang()) => App.getStoredData(name, _lang);

export const getDataWithDefault = (name, options) => {
  const { lang: _lang = lang(), key = 'items', defaultValue = [] } = options;
  const data = App.getStoredData(name, _lang, false);
  return data && data[key] ? data[key] : defaultValue;
};

// getAllLocalizedData :: (String, String) -> [[a]]
export const getAllLocalizedData = (name, unwrap_prop, defaultData = []) => R.map(
  R.pipe(
    lang => getData(name, lang),
    R.propOr(defaultData, unwrap_prop)
  ),
  langs()
);

export const scdata = _ => getData('scdata').shoppingCenterData;
export const scimddata = _ => getData('scimddata', 'all').shoppingCenterImdData;
export const storelist = _ => getData('storelist');
export const lunchlist = _ => getData('lunchlist', 'all');
export const servicelocations = _ => getData('servicelocations', 'all').serviceLocations || [];

export const sortByOrder = R.sortBy(R.prop('order'));

// getIMDs :: () -> [IMD]
export const getIMDs = _ => {
  const { imds = [] } = scimddata() || {};
  return imds;
};

// getIMD :: Int -> IMD
export const getIMD = id => {
  const imd = getIMDs().find(x => x.id == id);
  imd.floorIndex = getFloors().findIndex(x => x.id == imd.floorId);
  return imd;
};

// getFOB :: Number -> String
export const getFOB = id => {
  const fobs = scdata().fieldsOfBusiness || [];
  return fobs.find(x => x.id == id);
};

// getAllFloors :: () -> { floors: [Floor] officeTowerFloors: [Floor] }
export const getAllFloors = () => (
  {
    floors: getFloors(),
    officeTowerFloors: getOfficeTowerFloors()
  }
);

// getFloorById :: Int -> Floor
export const getFloorById = id => getFloors().concat(
  getOfficeTowerFloors()
).find(floor => floor.id == id);

// getFloors :: () -> [Floor]
export const getFloors = _ => {
  const floors = scdata().floors;
  return sortByOrder(floors);
};

// getFloorsMap :: () -> Object
export const getFloorsMap = _ => getFloors().reduce(
  (acc, f) => (acc[f.id] = f, acc), {});

// getOffers :: () -> [Offer]
export const getOffers = () => {
  const { offers } = App.getStoredData('offers', lang());
  return offers;
};

// getOfferById :: Number -> Offer
export const getOfferById = id => {
  return getOffers().find(x => x.id == id);
};

// getOfferListDataById :: Number -> Offer
export const getOfferListDataById = id => {
  const offer = getOfferById(id);
  if (offer) {
    // Shopping center offers won't have store
    const { logoURL } = offer.store && getStoreById(offer.store.id) || {};
    // return Object.assign({}, offer, { logoURL });
    return R.assoc('logoURL', logoURL, offer);
  }
  return null;
};

// getOfficeTowerById :: Int -> OfficeTower
export const getOfficeTowerById = id => getOfficeTowers().find(tower => tower.id == id);

// getOfficeTowers :: () -> [OfficeTower]
export const getOfficeTowers = () => scdata().officeTowers || [];

// getOfficeTowersWithTenants :: () -> [OfficeTower]
export const getOfficeTowersWithTenants = () => {
  const stores = getStores();
  const matchTower = id => ({ floor = {} }) => floor.officeTowerId == id;
  const hasStore = ({id}) => stores.some(matchTower(id));
  return getOfficeTowers().filter(hasStore);
};

// getOfficeTowerFloors :: () -> [OfficeTower]
export const getOfficeTowerFloors = () => scdata().officeTowerFloors || [];

export const getOpeningHours = () => {
  const { openingHours } = App.getStoredData('openingHours', 'all');
  return openingHours;
};

// getNewsAndEvents :: () -> [NewsEvent]
export const getNewsAndEvents = () => {
  const { news = [] } = getData('news');
  const now = new Date();
  return news.filter(item => new Date(item.publishDate) <= now);
};

// getNewsAndEventById :: Number -> [NewsEvent]
export const getNewsAndEventById = id => {
  const { news } = getData('news');
  return news.find(x => x.id == id);
};

// getStores :: () -> [Store]
export const getStores = () => {
  return storelist().stores;
};

//getLunchMenus :: () -> [LunchMenu]
export const getLunchMenus = () => {
  return lunchlist().lunchMenus;
};

// getLunchById :: Number -> LunchMenu
export const getLunchById = id => {
  return getLunchMenus().find(lunch => lunch.id == id);
};

// getStoreBySpaceCode :: String -> Store
export const getStoreBySpaceCode = spaceCode => {
  if (!spaceCode) return null;

  const codeMatch = x => VG.splitCode(x.spaceCode)
    .some(code => code == spaceCode);

  return getStores().find(codeMatch);
};

// getStoreById :: Number -> Store
export const getStoreById = id => {
  return getStores().find(store => store.id == id);
};

// storeData :: (name, data, lang) -> void
export const storeData = (name, data, lang = 'all') => App.saveLocally(data, name, lang);

// storeDataForAll :: (name, data) -> void
export const storeDataForAll = (name, data) => {
  langs().forEach(lang => storeData(data, name, lang));
};

export const translations = (_langs = langs()) => App.getTranslations(_langs);

export const translateOrDefault = (key, _default = key, _lang = lang()) => translations([_lang])[_lang][key] || _default;
export const translate = (key, _lang = lang()) => translateOrDefault(key, `${_lang}:${key}`, _lang);
export const __ = translate;
